import { Component, OnInit, Inject } from '@angular/core';
import { ApiService } from '../../services/api/api.service';
import { AuthService } from '../../services/auth/auth.service';

import { ActivatedRoute } from '@angular/router';
import { Data } from '../../models/data';
import { NavController } from '@ionic/angular';
import { BarcodeScannerOptions, BarcodeScanner} from '@ionic-native/barcode-scanner/ngx';
import { MatDialog, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NgxSpinnerService } from 'ngx-spinner';

export interface DialogData {
  animal: string;
  name: string;
}

@Component({
  selector: 'app-ipr-payment',
  templateUrl: './ipr-payment.page.html',
  styleUrls: ['./ipr-payment.page.scss'],
})
export class IprPaymentPage implements OnInit {

  open(menu)
  {
    menu.openMenu();
  }
  
  data = new Data();
  myId: any;
  payment = {
    price: null,
    qty: null,
    amount: null
  };
  product: any;
  //products = [];
  scannedData: any;
  barcodeScannerOptions: BarcodeScannerOptions;
  active = false;
  verify = false;
  error = false;
  myresponse: any;
  

  is_qty = false;
  is_amount = false;

  current_year: number = new Date().getFullYear();

  constructor(private apiService: ApiService, private authService: AuthService, private activatedRoute: ActivatedRoute, private barcodeScanner: BarcodeScanner, private navCtrl: NavController, public dialog: MatDialog, private spinner: NgxSpinnerService) {

    this.myId = this.activatedRoute.snapshot.paramMap.get('myid');
    this.data =  {
      id: 4,
      name: 'getProduct',
      content: this.myId
    };

    this.barcodeScannerOptions = {
      showTorchButton: true,
      showFlipCameraButton: true
    };

  }

  ngOnInit() {
    this.apiService.postData(this.data).subscribe((response) => {
      this.product = response.data;
    }); 

  }

  getCatName() {
    if (this.product) {
      return this.product[0].dexpay_label;
    } else {
      return null;
    }
  }

  getProdName() {
    if (this.product) {
      return this.product[0].name;
    } else {
      return null;
    }
  }

  getProdPrice() 
  {
    if (this.product) 
    {
      this.payment.price = this.product[0].priceIPR;     
      //this.payment.price = Number.parseFloat(this.product[0].priceIPR);
      //this.payment.price = this.payment.price.toFixed(2);
      return this.payment.price;
    }    
    else 
    {
      return null;
    }
  }


  getProdImage() {
    if (this.product) {
      return '/assets/img/' + this.product[0].image;
    } else {
      return null;
    }
  }

  scanCode2() {
      this.barcodeScanner
        .scan()
        .then(barcodeData => {
          this.scannedData = barcodeData;
          this.payment.amount = this.scannedData.text;
        })
        .catch(err => {
          console.log('Error', err);
        });
  } 
  
  checkInput() {
    if (this.myId) 
    {
      if (this.payment.qty.length == 1 || this.payment.qty.length <= 3)
      {
        this.active = true;
      }
      else{
        this.active = false;
      }
    }

  }

  
  total()
  {
    this.payment.price = this.product[0].priceIPR;

    this.payment.amount = this.payment.price * this.payment.qty;
    this.payment.amount = this.payment.amount.toFixed(2);

    this.is_amount = true;

  }

  verification2()
  {
    this.verify = true;
    switch (this.myId) 
    {
      case '1': {
        this.myId = 4208; 
      }; 
      case '2': {
        this.myId = 4209; 
      };
    break;
    }
    console.log('VERIFY' + this.myId);

    const stock = {
        id: 10,
        prodqty: this.payment.qty,
        productid: this.myId
    };

    this.data =  {
        id: 10,
        name: 'checkQtyStock',
        content: stock
    };

    this.apiService.postData(this.data).subscribe((response) => {
      if ( response.data[0].isokay === 1 ) {
        this.verify = true;
        alert('Your item is in available stock..');
        this.error = false;
      } 
      else if (response.data[0].isokay === 0)
      {
        this.verify = false;
        alert('Sorry, there is not enough stock!');
        this.navCtrl.navigateForward('/members/ipr-vm');
        this.error = true;
      }
    });

  }

  verification() 
  {
    console.log(this.payment.qty + 'QTY' + this.payment.amount + 'AMOUNT');
    console.log((this.payment.qty * this.payment.amount) + 'TOTAL');

    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - (this.payment.qty * this.payment.amount);
    const decimalbalance = balance.toFixed(2);

    console.log(test + 'wallet' + balance + 'paid' + this.payment.amount + decimalbalance);

      
    const stock = {
        id: 10,
        prodqty: this.payment.qty,
        productid: this.myId
    };

    this.data =  {
        id: 10,
        name: 'checkQtyStock',
        content: stock
    };

    console.log(this.payment.qty + this.myId + 'stock');

    this.apiService.postData(this.data).subscribe((response) => {
      //console.log(response);
      if (response.data[0].isokay === 1 ) 
      {
        this.verify = true;
        alert('Your item is in available stock..');
        this.error = false;
      } 
      else if (response.data[0].isokay === 0)
      {
        this.verify = false;
        alert('Sorry, there is not enough stock!');
        this.navCtrl.navigateForward('/members/ipr-vm');
        this.error = true;

      }
     
    });
  }

  
  submit() {
    this.spinner.show();

    const wallet = localStorage.getItem('wallet');
    const test = wallet.replace(',', '');
    const balance = Number.parseFloat(test) - this.payment.amount;
    const decimalbalance = balance.toFixed(2);

    console.log(test + ' ' + balance + '' + decimalbalance);

    if (Number.parseFloat(test) >= this.payment.amount ) {
    const dt = {
        mobile: this.payment.qty,
        amount: this.payment.amount,
        product: this.myId,
        user: localStorage.getItem('user'),
        order: null,
		    rrp: this.payment.amount
      };

    this.data =  {
        id: 5,
        name: 'addOrder',
        content: dt
    };
    this.apiService.pay(this.data).subscribe((response) => {

        this.data.content.order = response;
        this.apiService.wallet(this.data).subscribe((res) => {
          this.navCtrl.navigateForward('/members/success/' + response);
          this.myresponse = res;

          if (this.myresponse === 'Failed') 
          {
            this.navCtrl.navigateForward('/members/failed/1');
            this.spinner.hide();
          } 
          else 
          {
            this.navCtrl.navigateForward('/members/success/' + response);
            localStorage.setItem('wallet', balance.toString());
            this.spinner.hide();
          }
      });
    });

    } else {
      this.verify = false;
      this.openDialog();
      this.spinner.hide();
    }

  }


  openDialog(): void {
    const dialogRef = this.dialog.open(DialogIPRPage, {
      width: '280px',
      data: {name: 'name', animal: 'hello'}
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed');
    });
  }

  
  
  getMaxLimit() {
    if (this.myId === '126' || this.myId === '127' || this.myId === '200' || this.myId === '123' || this.myId === '146' || this.myId === '147' || this.myId === '149' || this.myId === '203' || this.myId === '204' || this.myId === '124') {
      return 12;
    }if (this.myId === '148' || this.myId === '128' || this.myId === '130' || this.myId === '131' || this.myId === '132' || this.myId === '133' || this.myId === '134' || this.myId === '135' || this.myId === '137') {
      return 13;
    } if (this.myId === '136' || this.myId === '140' || this.myId === '197') {
      return 16;
    } if (this.myId === '138' || this.myId === '120') {
      return 15;
    } if (this.myId === '142' || this.myId === '198') {
      return 17;
    } if (this.myId === '116') {
      return 8;
    } if (this.myId === '199') {
      return 9;
    } if (this.myId === '117' || this.myId === '125' || this.myId === '139' || this.myId === '196' || this.myId === '144') {
      return 10;
    } if (this.myId === '118' || this.myId === '121' || this.myId === '143') {
      return 11;
    } if (this.myId === '119') {
      return 7;
    } if (this.myId === '141' || this.myId === '122'){
      return 14;
    } else 
    {
      return 0;
    }
  }




  getInputLabel() {
    if (this.myId === '128' || this.myId === '131' ||  this.myId === '132' ||  this.myId === '133' ||  this.myId === '134' ||  this.myId === '135' || this.myId === '126' || this.myId === '146' || this.myId === '147' || this.myId === '116' || this.myId === '117' || this.myId === '118' || this.myId === '119' || this.myId === '120' || this.myId === '121' || this.myId === '122' || this.myId === '125' || this.myId === '130' || this.myId === '198' || this.myId === '136' || this.myId === '137' || this.myId === '138' || this.myId === '139' || this.myId === '140' || this.myId === '141' || this.myId === '142' || this.myId === '149' || this.myId === '144' || this.myId === '148' || this.myId === '196' || this.myId === '199') {
      return 'Account No';
    }else if (this.myId === '124' || this.myId === '200' || this.myId === '203' || this.myId === '204') {
      return 'Mobile No';
    }else if (this.myId === '123' || this.myId === '127' || this.myId === '143') {
      return 'Account No/Mobile No';
    }else if (this.myId === '197') {
      return 'Credit Card No/Account No';
    }else {
      return null;
    }
  }

  getTransactionProcess() {
    if (this.myId === '125' || this.myId === '126' || this.myId === '136' || this.myId === '142' || this.myId === '146' || this.myId === '147' || this.myId === '196' || this.myId === '127' || this.myId === '144' || this.myId === '199' || this.myId === '148'){
      return '1. Will process after 20 minutes.';
    }else if (this.myId === '116' || this.myId === '117' || this.myId === '119' || this.myId === '120' || this.myId === '121' || this.myId === '122' || this.myId === '128' || this.myId === '137' || this.myId === '138' || this.myId === '139' || this.myId === '140' || this.myId === '141' || this.myId === '149' || this.myId === '130' || this.myId === '131' || this.myId === '132' || this.myId === '133' || this.myId === '134' || this.myId === '135' || this.myId === '197' || this.myId === '123') {
      return '1. Within 3 working days.';
    }else if (this.myId === '118') {
      return '1. Within 24 hours.';
    }else if (this.myId === '200' || this.myId === '203' || this.myId === '204') {
      return '1. Will process immediately.';
    }else {
      return '**No Transaction Process information regarding this product.';
    }
  }

  logout() {
    this.authService.logout();
  }

}

@Component({
  selector: 'mydialog',
  templateUrl: 'dialog.html',
})
export class DialogIPRPage {
  constructor(
    @Inject(MAT_DIALOG_DATA) public data: DialogData) {}

}
